import { useEffect as n } from "react";
function d(t) {
  n(() => {
    if (!document || !t)
      return () => {
      };
    if (document.querySelector(`link[href="${t}"]`))
      return () => {
      };
    const e = document.createElement("link");
    return e.rel = "stylesheet", e.href = t, e.type = "text/css", document.head.append(e), () => {
      e.remove();
    };
  }, [t]);
}
export {
  d as useStyle
};
//# sourceMappingURL=useStyle.js.map
